<template>
  <div>
    <!-- video counselor -->
    <div
      v-if="is_counselor"
      class="fixed top-0 left-0 h-full w-full flex items-center justify-center bg-black bg-opacity-60 mdl:z-50"
    >
      <div class="bg-[#e2e7eb] w-[368px] rounded-xl p-2 relative">
        <!-- Close Button -->
        <button
          @click="showTooltip = true"
          class="absolute top-[-10px] right-[-8px] bg-white text-black w-8 h-8 rounded-full p-1"
        >
          ✕
        </button>

        <!-- Tooltip Confirmation -->
        <div
          v-if="showTooltip"
          class="absolute top-5 right-3 bg-white text-black p-2 rounded-lg shadow-md w-[120px]"
        >
          <p class="text-sm">Are you sure?</p>
          <div class="flex justify-between mt-2">
            <button
              @click="closeIframe"
              class="bg-red-500 text-white px-2 py-1 rounded-lg text-sm w-[50px]"
            >
              Yes
            </button>
            <button
              @click="showTooltip = false"
              class="bg-gray-300 text-black px-2 py-1 rounded-lg text-sm w-[50px]"
            >
              No
            </button>
          </div>
        </div>

        <!-- Iframe -->
        <iframe
          :src="iframeSrc"
          name="onlinejain"
          width="350px"
          height="500px"
          style="border: 2px solid #f6f5f4; border-radius: 10px"
          allow="camera *;microphone *;display-capture *"
        ></iframe>
      </div>
    </div>

    <!-- floating contact elements -->
    <div class="hidden lg:block">
      <div class="fixed top-[30%] right-5 flex flex-col gap-3 z-50">
        <button
          @click="openIframeWithUTM"
          v-if="!isGlNumber && !isGlNumberMca && !isGlNumberBba"
        >
          <div
            class="hover-tooltip sticky-hover bg-black w-[42px] h-[42px] rounded-full flex items-center justify-center"
          >
            <img
              src="@/assets/home/cam-recorder.webp"
              alt="whatsapp"
              class="w-[22px] h-[22px] object-contain"
            />
            <span class="cbs-tooltip text-start font-bold">
              Hey there!
              <br />
              Do you have any questions? Let's talk!
            </span>
          </div>
        </button>
        <a
          href="tel:+91 8047184883"
          v-if="isGlNumber"
          @click="handleClick('Phone Call')"
        >
          <div
            class="hover-tooltip sticky-hover bg-black rounded-full p-3 w-[42px] h-[42px] flex items-center justify-center"
          >
            <img
              src="@/assets/home/phone.svg"
              alt="phone"
              class="w-[17px] h-[17px] object-contain"
            />
            <span
              class="cbs-tooltip text-start font-bold flex items-center gap-2"
            >
              <img
                src="@/assets/home/phone.svg"
                alt="phone"
                class="w-[17px] h-[17px] object-contain"
              />
              +918047184883
            </span>
          </div>
        </a>
        <a
          href="tel:+91 8047184884"
          v-else-if="isGlNumberMca"
          @click="handleClick('Phone Call')"
        >
          <div
            class="hover-tooltip sticky-hover bg-black rounded-full p-3 w-[42px] h-[42px] flex items-center justify-center"
          >
            <img
              src="@/assets/home/phone.svg"
              alt="phone"
              class="w-[17px] h-[17px] object-contain"
            />
            <span
              class="cbs-tooltip text-start font-bold flex items-center gap-2"
            >
              <img
                src="@/assets/home/phone.svg"
                alt="phone"
                class="w-[17px] h-[17px] object-contain"
              />
              +918047184884
            </span>
          </div>
        </a>
        <a
          href="tel:+91 8045681263"
          v-else-if="isGlNumberBba"
          @click="handleClick('Phone Call')"
        >
          <div
            class="hover-tooltip sticky-hover bg-black rounded-full p-3 w-[42px] h-[42px] flex items-center justify-center"
          >
            <img
              src="@/assets/home/phone.svg"
              alt="phone"
              class="w-[17px] h-[17px] object-contain"
            />
            <span
              class="cbs-tooltip text-start font-bold flex items-center gap-2"
            >
              <img
                src="@/assets/home/phone.svg"
                alt="phone"
                class="w-[17px] h-[17px] object-contain"
              />
              +918045681263
            </span>
          </div>
        </a>
        <a href="tel:+919240013644" v-else @click="handleClick('Phone Call')">
          <div
            class="hover-tooltip sticky-hover bg-black rounded-full p-3 w-[42px] h-[42px] flex items-center justify-center"
          >
            <img
              src="@/assets/home/phone.svg"
              alt="phone"
              class="w-[17px] h-[17px] object-contain"
            />
            <span
              class="cbs-tooltip text-start font-bold flex items-center gap-2"
            >
              <img
                src="@/assets/home/phone.svg"
                alt="phone"
                class="w-[17px] h-[17px] object-contain"
              />
              +919240013644
            </span>
          </div>
        </a>
        <a
          :href="whatsAppLink"
          target="_blank"
          v-if="!isGlNumber && !isGlNumberMca && !isGlNumberBba"
          @click="handleClick('WhatsApp')"
        >
          <div
            class="bg-black w-[42px] h-[42px] rounded-full flex items-center justify-center"
          >
            <img
              src="@/assets/home/whatsapp-logo.svg"
              alt="whatsapp"
              class="w-[17px] h-[17px] object-contain"
            />
          </div>
        </a>
      </div>
    </div>
    <!-- mobile social media -->
    <div class="md:hidden w-full py-3">
      <div class="fixed bottom-0 bg-white border w-full h-[70px]">
        <div class="flex gap-4 justify-around items-center h-full">
          <a :href="dynamicHref" target="blank" @click="handleApplyNowClick">
            <img
              src="@/assets/home/socialMedia/graduation.webp"
              class="w-[40px] h-[40px] object-contain"
              alt="graduation"
            />
            <p class="text-[10px]">Apply Now</p>
          </a>
          <a
            :href="whatsAppLink"
            target="blank"
            v-if="!isGlNumber && !isGlNumberMca && !isGlNumberBba"
            @click="handleClick('WhatsApp')"
          >
            <img
              src="@/assets/home/socialMedia/whatsapp.webp"
              class="w-[40px] h-[40px] object-contain"
              alt="whatsapp logo"
            />
            <p class="text-[10px]">WhatsApp</p>
          </a>
          <div v-if="!isGlNumber && !isGlNumberMca && !isGlNumberBba">
            <!-- video counselor -->
            <button
              @click="
                is_counselor = true;
                handleClick('Video Counselling');
              "
            >
              <div
                class="bg-[#f8c300] w-[42px] h-[42px] rounded-full flex items-center justify-center"
              >
                <img
                  src="@/assets/home/cam-recorder.webp"
                  alt="Video Counselling"
                  class="w-[30px] h-[40px] object-contain"
                />
              </div>
            </button>
            <p class="text-[10px]">Video Counselling</p>
          </div>

          <a
            href="tel:+918047184883"
            target="blank"
            v-if="isGlNumber"
            @click="handleClick('Phone Call')"
          >
            <img
              src="@/assets/home/socialMedia/phone.webp"
              class="w-[40px] h-[40px] object-contain"
              alt="phone"
            />
            <p class="text-[10px]">Call Us</p>
          </a>
          <a
            href="tel:+918047184883"
            target="blank"
            v-else-if="isGlNumberMca"
            @click="handleClick('Phone Call')"
          >
            <img
              src="@/assets/home/socialMedia/phone.webp"
              class="w-[40px] h-[40px] object-contain"
              alt="phone"
            />
            <p class="text-[10px]">Call Us</p>
          </a>
          <a
            href="tel:+918045681263"
            target="blank"
            v-else-if="isGlNumberBba"
            @click="handleClick('Phone Call')"
          >
            <img
              src="@/assets/home/socialMedia/phone.webp"
              class="w-[40px] h-[40px] object-contain"
              alt="phone"
            />
            <p class="text-[10px]">Call Us</p>
          </a>
          <a
            href="tel:+919240013644"
            target="blank"
            v-else
            @click="handleClick('Phone Call')"
          >
            <img
              src="@/assets/home/socialMedia/phone.webp"
              class="w-[40px] h-[40px] object-contain"
              alt="phone"
            />
            <p class="text-[10px]">Call Us</p>
          </a>
        </div>
      </div>
    </div>
    <!-- Chat Bot -->
    <!-- <div class="npf_chatbots" data-w="42f312018fdd4668a5cd884fcd0028a9" style="display: none"></div> -->
  </div>
</template>

<script>
import { computed } from "vue";
// import $ from "jquery";

export default {
  name: "SocialMedia",
  data() {
    return {
      is_counselor: false,
      showTooltip: false,
      isGlNumber: false,
      isGlNumberMca: false,
      isGlNumberBba: false,
      whatsAppLink: "",
      source: "",
      medium: "",
      campaign: "",
      adgroupid: "",
      creativeid: "",
      device: "",
      network: "",
      campaignid: "",
      matchtype: "",
      keyword: "",
      placement: "",
      channel: "",
      url: "",
      iframeBaseUrl: "https://zipme.at/usdcglobal-meetings",
    };
  },
  async created() {
    if (this.$route.path == "/online-mba/data-science") {
      this.isGlNumber = true;
    } else if (
      this.$route.path == "/online-mba/digital-marketing-and-ecommerce"
    ) {
      this.isGlNumber = true;
    } else if (this.$route.path == "/online-mca/full-stack-development") {
      this.isGlNumberMca = true;
    } else if (this.$route.path == "/online-mca/cloud-computing") {
      this.isGlNumberMca = true;
    } else if (this.$route.path == "/online-mca/data-science") {
      this.isGlNumberMca = true;
    } else if (this.$route.path == "/online-mca/artificial-intelligence") {
      this.isGlNumberMca = true;
    } else if (this.$route.path == "/online-bba/digital-marketing") {
      this.isGlNumberBba = true;
    } else if (this.$route.path == "/online-bba/data-science-and-analytics") {
      this.isGlNumberBba = true;
    }
    this.updateUTMParams(this.$route.query);
  },
  computed: {
    dynamicHref() {
     // const currentPath = this.$route.path;
     // if (currentPath === "/online-mba/data-science") {
     //   return "https://onlinejain.com/gl/mba-data-science-digital-marketing-jain-registration.html?utm_source=university_website&utm_medium=first_scroll&utm_campaign=applynow_onlinejain";
     // } else if (
     //   currentPath === "/online-mba/digital-marketing-and-ecommerce"
     // ) {
     //   return "https://onlinejain.com/gl/mba-data-science-digital-marketing-jain-registration.html?utm_source=university_website&utm_medium=first_scroll&utm_campaign=applynow_onlinejain";
     // } else if (currentPath === "/online-mca/cloud-computing") {
     //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=first_scroll&utm_campaign=applynow_onlinejain";
     // } else if (currentPath === "/online-mca/full-stack-development") {
     //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=first_scroll&utm_campaign=applynow_onlinejain";
     // } else if (currentPath === "/online-mca/data-science") {
     //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=first_scroll&utm_campaign=applynow_onlinejain";
     // } else if (currentPath === "/online-mca/artificial-intelligence") {
     //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html?utm_source=university_website&utm_medium=first_scroll&utm_campaign=applynow_onlinejain";
     // } else if (currentPath === "/online-bba/digital-marketing") {
     //   return "https://onlinejain.com/gl/bba-degree-jain-online-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
     // } else if (currentPath === "/online-bba/data-science-and-analytics") {
     //   return "https://onlinejain.com/gl/bba-degree-jain-online-registration.html?utm_source=university_website&utm_medium=second_scroll&utm_campaign=applynow_onlinejain";
     // } else {
     //   return "https://apply.onlinejain.com/";
     // }
     return "https://application.onlinejain.com/"
    },
    iframeSrc() {
      // Create an object of query parameters
      const params = {
        utm_source: this.source,
        utm_medium: this.medium,
        utm_campaign: this.campaign,
        utm_adgroupid: this.adgroupid,
        utm_creativeid: this.creativeid,
        utm_device: this.device,
        utm_network: this.network,
        utm_campaignid: this.campaignid,
        utm_matchtype: this.matchtype,
        utm_keyword: this.keyword,
        utm_placement: this.placement,
        utmChannel: "Zip Team" || "",
        utmURL: window.location.href || "",
      };

      // Filter out empty parameters
      const queryString = Object.entries(params)
        .filter(([key, value]) => value) // Remove keys with empty values
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");

      // Return the complete iframe URL
      return queryString
        ? `${this.iframeBaseUrl}?${queryString}`
        : this.iframeBaseUrl;
    },
  },
  methods: {
    handleClick(platform) {
      dataLayer.push({
        event: "Social Clicked",
        Attribute: {
          Platform: platform,
        },
      });

      if (platform === "Video Call") {
        this.is_counselor = true;
      }
    },
    handleApplyNowClick() {
      dataLayer.push({
        event: "Apply Online Initiated",
        Attribute: {
          CTA: "Apply Now",
          "Section Name": "Mobile Social Icon",
        },
      });
    },
    setWhatsAppLink() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      const baseWhatsAppURL =
        "https://api.whatsapp.com/send/?phone=+916364007160&app_absent=0";

      // Set the text parameter based on device type
      const text = isMobile ? "Hello" : "Hi";
      this.whatsAppLink = `${baseWhatsAppURL}&text=${encodeURIComponent(text)}`;
    },
    handleClick(platform) {
      console.log(`User clicked on: ${platform}`);
    },
    updateUTMParams(newParams) {
      this.source = newParams.utm_source || "";
      this.medium = newParams.utm_medium || "";
      this.campaign = newParams.utm_campaign || "";
      this.adgroupid = newParams.utm_adgroupid || "";
      this.creativeid = newParams.utm_creativeid || "";
      this.device = newParams.utm_device || "";
      this.network = newParams.utm_network || "";
      this.campaignid = newParams.utm_campaignid || "";
      this.matchtype = newParams.utm_matchtype || "";
      this.keyword = newParams.utm_keyword || "";
      this.placement = newParams.utm_placement || "";
      this.channel = newParams.utmChannel || "Zip Team";
      this.url = newParams.utmURL || "";
    },
    openIframeWithUTM() {
      this.is_counselor = true; // Open the iframe
      this.updateUTMParams(this.$route.query); // Update UTM parameters from current route
    },
    closeIframe() {
      this.is_counselor = false;
      this.showTooltip = false;
    },
  },
  mounted() {
    // this.$nextTick(()=>{
    //   var s = document.createElement("script");
    //   s.type = "text/javascript";
    //   s.async = true;
    //   s.src =
    //     "https://chatbot.in5.nopaperforms.com/en-gb/backend/bots/niaachtbtscpt.js/50056145b5e5881c2/42f312018fdd4668a5cd884fcd0028a9";
    //   document.body.appendChild(s);
    //   setTimeout(() => {
    //     // image alt name update
    //     $(document).ready(function () {
    //       var chatBotContainerTag = $("#__eechatIcon");

    //       if (chatBotContainerTag) {
    //         var imageTag = chatBotContainerTag.find("img");

    //         if (imageTag) {
    //           imageTag.attr({ "alt": "JAIN Online Chatbot", "width": "60", "height": "60" });

    //         }
    //       }
    //       var iframeTag = $("#chatbox_frame");
    //       iframeTag.attr("title", "JAIN Online Chatbot");
    //     });
    //   }, 2500);
    // })
    this.setWhatsAppLink();
  },
};
</script>

<style></style>
